/**
 * @license Copyright (c) 2003-2017, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * @module utils/tomap
 */

import isPlainObject from './lib/lodash/isPlainObject';
import objectToMap from './objecttomap';

/**
 * Transforms object or iterable to map. Iterable needs to be in the format acceptable by the `Map` constructor.
 *
 *		map = toMap( { 'foo': 1, 'bar': 2 } );
 *		map = toMap( [ [ 'foo', 1 ], [ 'bar', 2 ] ] );
 *		map = toMap( anotherMap );
 *
 * @param {Object|Iterable} data Object or iterable to transform.
 * @returns {Map} Map created from data.
 */
export default function toMap( data ) {
	if ( isPlainObject( data ) ) {
		return objectToMap( data );
	} else {
		return new Map( data );
	}
}



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/tomap.js
// module id = null
// module chunks = 